import { render, staticRenderFns } from "./ThemeSelector.vue?vue&type=template&id=56d12d8b&scoped=true&lang=pug&"
import script from "./ThemeSelector.vue?vue&type=script&lang=js&"
export * from "./ThemeSelector.vue?vue&type=script&lang=js&"
import style0 from "./ThemeSelector.vue?vue&type=style&index=0&id=56d12d8b&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d12d8b",
  null
  
)

export default component.exports